var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 123,
    viewBox: "0 0 1280 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.5 78.0206C266 137.021 46 8.52058 -98 34.5206V147.521H1182.5V62.0206C1097.5 106.687 914.3 176.921 861.5 100.521C795.5 5.02063 551 19.0206 408.5 78.0206Z",
    fill: "#C996CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373 57.6474C215 14.6474 79.5 66.1474 -2 123.647H1280.5V12.1473C1210.5 2.98067 1041 -9.85266 923 12.1473C775.5 39.6473 531 100.647 373 57.6474Z",
    fill: "#3D2C8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerHero);
export default __webpack_public_path__ + "static/media/divider_hero.f7f21e952f2f76c7b0b28648620df4cf.svg";
export { ForwardRef as ReactComponent };